/** 手机使用要求：操作组可换行，表单在窄屏按单列阅读；不改变既有权限、数据与审批规则。 */
import React, { useState } from "react";
import { Loader2, Stamp } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "../ui/sonner";
import { PayeeContextPanel } from "./PayeeContext";

const money = (n) => "$" + Number(n || 0).toLocaleString();

/* 工程部经理「复核通过 → 入财务」确认框：实时显示同收款方本项目全部出款 + 疑似重复须勾选确认 */
export function EngReviewDialog({ r, zh, api, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [dup, setDup] = useState({ needConfirm: false, confirmed: false, loaded: false });
  const blocked = !dup.loaded || (dup.needConfirm && !dup.confirmed);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/payment-requests/${r.id}/action`, { action: "eng_review", note: note.trim(), dupConfirmed: dup.needConfirm && dup.confirmed });
      toast.success(zh ? "复核通过，已入财务（建账单 + 待打印支票）" : "Approved → finance");
      onDone();
    } catch (e) { toast.error(e?.detailText || e.message); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="eng-review-dialog">
        <DialogHeader>
          <DialogTitle className="text-sm">{zh ? "复核通过 → 入财务" : "Review OK → Finance"}</DialogTitle>
          <DialogDescription className="text-[11px]">{r.tradeName}{r.subcontractorName ? ` · ${r.subcontractorName}` : ""} · {r.milestoneName} · <b className="text-slate-900">{money(r.amount)}</b>{zh ? "：通过后自动建账单并生成待打印支票。" : ""}</DialogDescription>
        </DialogHeader>
        <PayeeContextPanel api={api} rid={r.id} zh={zh} onState={setDup} testid="eng-review-payee" />
        <textarea data-testid="eng-review-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder={zh ? "复核意见（可选）" : "Review note (optional)"} className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2" />
        <div className="flex-wrap md:flex-nowrap flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onClose} data-testid="eng-review-cancel">{zh ? "取消" : "Cancel"}</Button>
          <Button size="sm" disabled={busy || blocked} onClick={submit} data-testid="eng-review-submit" className="bg-brand-500 hover:bg-brand-600 text-white">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Stamp className="h-3.5 w-3.5 mr-1" />{zh ? "确认通过" : "Approve"}</>}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
